export const routes = {
  initial: "/menu",
  food: "/menu/category",
  cart: "/menu/cart",
  verify: "/menu/verify"
};
